'use client';

import { FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const OFFICIAL_SECTION_EMPTY_KEY = 'official-section-empty';

export function createEmptySection() {
    return combineComponent(i18n.gettext('區塊'), [], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        primaryGridPresetStyle: {
            [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '500px',
            [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]: '',
            [FEATURE_FLAG_KEYS.GRID_GAP]: '0px',
            [FEATURE_FLAG_KEYS.FIXED_SCREEN_HEIGHT]: false,
            [FEATURE_FLAG_KEYS.PADDING_TOP]: '0px',
            [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '0px',
        },
        shouldWrap: true,
    });
}
